import { useMediaQuery } from '@mantine/hooks'
import { Navbar } from 'widgets/Navbar'
import { Sidebar } from 'widgets/Sidebar'

export const NavigationProvider = () => {
    const navbarOrSidebar = useMediaQuery('(min-width: 62em)')

    return <>{navbarOrSidebar ? <Sidebar /> : <Navbar />}</>
}
